export const CANCELLATION_TYPES = {
  NO_LONGER_NEEDED: 'NO_LONGER_NEEDED',
  BY_MISTAKE: 'BY_MISTAKE',
  DELIVERY_ISSUE: 'DELIVERY_ISSUE',
  CUSTOM: 'CUSTOM',
};
